const DEFAULT = 0;
export let score = DEFAULT;

export function setDefault() {
    score = DEFAULT;
}

export function incrementScore() {
    score++;
}